module.exports = __webpack_public_path__ + "img/five_.79b2bee9.png";